import React, {useState} from 'react';

import * as S from './HotelCardImageGallery.styles';
import GoStaysPromises from '../GoStaysPromises/GoStaysPromises';
import GoStaysIcon from '../../../../../stories/Icons/GoStaysIcon';
import {defaultTheme} from 'build-theme/src/build-theme';

import fallbackImage from '../../../../assets/fallback-image.png';

import ArrowRightDetailIcon from '../../../../../stories/Icons/ArrowRightDetailIcon';
import ArrowLeftDetailIcon from '../../../../../stories/Icons/ArrowLeftDetailIcon';

import useCarousel from '../../../../../shared/hooks/useCarousel';

const HotelCardImageGallery = ({
  data = [],
  limit = 5,
  navigateToDetailsPage,
  country = '',
  isGoStays = false,
  gostaysPromises = [],
  offerPersuasion = {},
}: {
  data: Array<string>;
  limit?: number;
  navigateToDetailsPage: Function;
  isGoStays: boolean;
  country: string;
  gostaysPromises?: Array<string>;
  offerPersuasion?:{
      text ?: string
  }

}) => {
  const [mainImage, setMainImage] = useState(data[0]);
  const [showCustomBanner, setShowCustomBanner] = useState(false);

  let hasCarousel = false;

  if (data.length > 1) {
    hasCarousel = true;
  }

  const {
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
    dataList,
  } = useCarousel(data, 1);

  const onClickHandler = () => {
    navigateToDetailsPage();
  };

  const previous = event => {
    event.stopPropagation();
    if (isLeftCursorActive) {
      decrement();
    }
  };

  const next = event => {
    event.stopPropagation();
    if (isRightCursorActive) {
      increment();
    }
  };

  return (
    <>
      <S.MainImageWrapperDivStyle>
        <S.IconWrapperLeft onClick={previous}>
          <ArrowLeftDetailIcon
            width={'1.2rem'}
            fill={
              isLeftCursorActive ? defaultTheme.colors.blue.brand : defaultTheme.colors.grey.grey50
            }
          />
        </S.IconWrapperLeft>
        {dataList.map(image => (
          <>
          {offerPersuasion.text ?  <S.UnstyledDiv>{offerPersuasion?.text}</S.UnstyledDiv> : null}
          <S.ImageStyle key={image} src={image} fallback={fallbackImage} onClick={onClickHandler} />
          </>
        ))}
        <S.IconWrapperRight onClick={next}>
          <ArrowRightDetailIcon
            width={'1.2rem'}
            fill={
              isRightCursorActive ? defaultTheme.colors.blue.brand : defaultTheme.colors.grey.grey50
            }
          />
        </S.IconWrapperRight>
      </S.MainImageWrapperDivStyle>
    </>
  );
};

export default HotelCardImageGallery;
